import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { SaciMaecfngimpr } from '../advantageinterfaces/sacimaecfngimpr';
import { SacimaecfngimprService } from '../advantageservices/sacimaecfngimpr.service';
import { ConfirmationService, MessageService } from 'primeng';
import { ReportesService } from '../../servicios/reporte.service';

@Component({
  selector: 'app-sacimaecfngimpr',
  templateUrl: './sacimaecfngimpr.component.html',
  styleUrls: ['./sacimaecfngimpr.component.css']
})
export class SacimaecfngimprComponent implements OnInit, OnChanges {
  @Input() auxiliar: any;
  @Input() strNombreForma: any;
  @Input() strNumDoc: any;
  @Input() strNotaVentaPV: any;
  @Input() strCampo: any;
  @Input() strCampo2: any;
  @Input() strNumDoc2: any;
  @Input() strform: any;//CDPJ
  @Input() botonExcel: any
  @Output() cerrar = new EventEmitter<boolean>();

  reportes: SaciMaecfngimpr[] = [];
  reporteSeleccionado: SaciMaecfngimpr;

  ValoresReporte: string[][] = [];
  ValoresParamentros: string[][] = [];
  intNumfilasVP: number;
  intNumFilasVR: number;
  strConsultaRP: string;
  strParametro: string;
  ValorParametroIDE: string;
  strObjeto: string;
  boolexcel: boolean;
  constructor(private cfngimprService: SacimaecfngimprService, private messageService: MessageService,
    private confirmationService: ConfirmationService, private reporteSer: ReportesService) {
  }

  ngOnInit(): void {
    this.reporteSeleccionado = {};
  }

  ngOnChanges(changes: SimpleChanges): void {
    for (const e in changes) {
      if (e === 'auxiliar' && this.strNombreForma !== undefined) {
        this.listarreportes();
      }
    }
  }

  listarreportes() {
    this.intNumfilasVP = 0;
    this.intNumFilasVR = 0;
    this.boolexcel = false;
    let strDatos = '';
    if (this.strNotaVentaPV === 'PV') {
      strDatos = 'PV';
    } else {
      strDatos = 'F';
    }
    console.log(this.strCampo, this.strNumDoc);
    if (this.strNumDoc === undefined) {
      this.strNumDoc = '';
    }

    if (this.strNombreForma === 'frmBAN_consilbancaria' || this.strNombreForma === 'frmCXC_TRNCOBRO') {
      this.FunCnfgMtrzRptConcil(this.strCampo, this.strNumDoc, this.strCampo2, this.strNumDoc2);
    } else {
      this.FunCnfgMtrzRpt(this.strCampo, this.strNumDoc);
    }


    this.cfngimprService.CargarReportesPantalla(this.strNombreForma, '01', strDatos).subscribe(data => {
      this.reportes = data;
    });
  }

  manejarSenales(valor) {
    if (valor === 'Reporte') {
      this.boolexcel = false;
      this.verReporte();
    }
    if (valor === 'Imprimir') {
      this.imprimir();
    }
    if (valor === 'Salir') {
      this.cerrar.emit(true);
    }
    if (valor === 'Excel') {
      this.boolexcel = true;
      this.verReporte();
    }
  }

  visualizarValorconsulta() {
    if (this.reporteSeleccionado === undefined) {
      this.messageService.add({
        key: 'cfngimpr',
        severity: 'success',
        summary: 'Información',
        detail: 'Seleccione un reporte'
      });
      return;
    }

    const strCodigoParam = this.reporteSeleccionado.CNFGIMPR_CODIGO;
    this.CargarParametrosReporte(strCodigoParam, 'mensaje');
  }

  CargarParametrosReporte(strCodigoParam, accion) {
    let i = 0;
    console.log(strCodigoParam);
    this.cfngimprService.consultaPrmtCnfgImprT(strCodigoParam, '01').subscribe(data => {
      for (const rs of data) {
        this.ValoresParamentros[i] = [];
        this.ValoresParamentros[i][0] = rs.PRMTCNFGIMPR_TIPO;
        this.ValoresParamentros[i][1] = rs.PRMTCNFGIMPR_VALOR;
        this.ValoresParamentros[i][2] = rs.PRMTCNFGIMPR_TIPODATO;
        i = i + 1;
      }
      this.intNumfilasVP = i;

      if (accion === 'mensaje') {
        this.strConsultaRP = this.FormarConsulta().trim();
        this.strConsultaRP = this.strConsultaRP.substring(3);
        this.confirmationService.confirm({
          message: this.strConsultaRP,
          header: 'Reporte',
          icon: 'pi pi-info-circle',
          key: 'confcfngimpr',
          acceptLabel: 'Ok',
          rejectVisible: false,
          accept: () => {
          }
        });
      }

      if (accion === 'visualizar') {
        this.visualizarReporte2();
      }
    });
  }

  FormarConsulta() {
    let strCadena = '';
    let strValorParam = '';
    let strCadenaFinal = '';

    for (let i = 0; i < this.intNumfilasVP; i++) {
      if (this.ValoresParamentros[i][0] === 'T') {
        strCadena = this.ValoresParamentros[i][1];
        strCadenaFinal = strCadenaFinal + ' ' + strCadena;
      } else {
        const strValor = this.ValoresParamentros[i][1];
        const strTipoValor = this.ValoresParamentros[i][2];
        for (let j = 0; j < this.intNumFilasVR; j++) {
          if (strValor === this.ValoresReporte[j][0]) {
            strValorParam = this.ValoresReporte[j][1];
            if (strTipoValor === 'S') {
              strValorParam = '\'' + strValorParam + '\'';
            }
            strCadenaFinal = strCadenaFinal + ' ' + strValorParam;
          }
        }
      }
    }

    if (this.reporteSeleccionado.CNFGIMPR_TABLA != null && this.reporteSeleccionado.CNFGIMPR_SP == null) {
      strCadenaFinal = ' WHERE ' + strCadenaFinal;
    } else {
      strCadenaFinal = ' AND ' + strCadenaFinal;
    }

    return strCadenaFinal;
  }

  verReporte() {
    if (this.reportes.length >= 0) {
      this.visualizarReporte();
    } else {
      this.messageService.add({
        key: 'cfngimpr',
        severity: 'error',
        summary: 'Información',
        detail: 'No existe ningún dato. Consulte con el Administrador'
      });
    }
  }

  visualizarReporte() {
    const strCodigoParam = this.reporteSeleccionado.CNFGIMPR_CODIGO;
    this.CargarParametrosReporte(strCodigoParam, 'visualizar');
  }

  visualizarReporte2() {
    let strPantallaArchivoRP = '';
    let strConsulta = this.FormarConsulta().trim();

    if (this.reporteSeleccionado.CNFGIMPR_SP !== null) {

      if (this.strParametro === '1') {
        strPantallaArchivoRP = 'PANTALLA' + this.reporteSeleccionado.CNFGIMPR_REPORTE;
      } else {
        strPantallaArchivoRP = this.reporteSeleccionado.CNFGIMPR_REPORTE;
      }

      this.cfngimprService.EjecutaSentenciaUpdate(this.FormarConsultaProceso()).subscribe();
      strConsulta = 'where ' + strConsulta.substring(4).trim() + ' AND PARAMETRO_IDE = ' + '\'' + this.ValorParametroIDE + '\'';

      /*setTimeout(() => {
        console.log(strConsulta);
        document.getElementById('areporte').click();
        
        const urlreporte = sessionStorage.getItem('urlreporte');
        const usuarioEsquema = JSON.parse(sessionStorage.getItem('usuarioEsquema'));
        const esquema = usuarioEsquema.esquema;
        let NOMBREREPORTE = strPantallaArchivoRP;
        NOMBREREPORTE = NOMBREREPORTE.substr(0, NOMBREREPORTE.length - 7);
        const src = urlreporte + NOMBREREPORTE + '.pdf?j_username=' + esquema + '&j_password=jasperadmin';
        // src = src + '&j_querryString=' + strConsulta;
        console.log(src);
        // http://localhost:8081/jasperserver/rest_v2/reports/reports/VEN_OP1_NOTAVENTA.pdf?j_username=DEMO&j_password=jasperadmin
        fetch(src).then(res => res.blob()).then(blob => {
          const fileURL = URL.createObjectURL(blob);
          window.open(fileURL);
        });
      }, 2000);*/


      setTimeout(() => {
        if (this.boolexcel === true) {
          let NOMBREREPORTE = this.reporteSeleccionado.CNFGIMPR_REPORTE;
          NOMBREREPORTE = NOMBREREPORTE.substr(0, NOMBREREPORTE.length - 7);
          strPantallaArchivoRP = NOMBREREPORTE + '_XLS.jasper';

          this.reporteSer.generarReporte(strPantallaArchivoRP, strConsulta, true, '').subscribe(response => {
            let base64: string = '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';
            base64 = response;
            let byteCharacters = atob(base64);
            let byteArrays = [];
            for (let offset = 0; offset < byteCharacters.length; offset += 512) {
              let slice = byteCharacters.slice(offset, offset + 512);
              let byteNumbers = new Array(slice.length);
              for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
              }
              let bytearray = new Uint8Array(byteNumbers);
              byteArrays.push(bytearray);
            }
            let blob = new Blob(byteArrays, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const fileURL = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.setAttribute('style', 'display: none;');
            a.href = fileURL;
            a.download = strPantallaArchivoRP + '.xlsx';
            a.click();
            window.URL.revokeObjectURL(fileURL);
          }, error => {
            this.messageService.add({
              key: 'cfngimpr',
              severity: 'error',
              summary: 'Error',
              detail: 'Error al generar el reporte. Revise la configuración'
            });
          });
        } else {
          const mediaType = 'application/pdf';
          this.reporteSer.generarReporte(strPantallaArchivoRP, strConsulta, false, '').subscribe(response => {
            const blob = new Blob([response], { type: mediaType });
            const fileURL = URL.createObjectURL(blob);

            window.open(fileURL);
          }, error => {
            this.messageService.add({
              key: 'cfngimpr',
              severity: 'error',
              summary: 'Error',
              detail: 'Error al generar el reporte. Revise la configuración'
            });
          });
        }


      }, 2000);
      /*
      Map < String, Object > param = new HashMap<String, Object>();
      param.put('querryString', strConsulta);
      param.put('SUBREPORT_DIR', AsistenteReportes.seleccionarInputStreamPantalla(strLocalizacionRP));
      param.put('NOMBRE_REPORTE', strNombreReporte);
      param.put('REPORT_LOCALE', new java.util.Locale('en', 'US'));
      
      try {
        AsistenteReportes.mostrarReportePantalla(strPantallaArchivoRP, param, strLocalizacionRP, 'P');
      }
      */
    } else {
      if (this.strParametro === '1') {
        strPantallaArchivoRP = 'PANTALLA' + this.reporteSeleccionado.CNFGIMPR_REPORTE;
      } else {
        strPantallaArchivoRP = this.reporteSeleccionado.CNFGIMPR_REPORTE;
      }

      setTimeout(() => {
        if (this.boolexcel === true) { 
        //if (this.excel === true) {
          let NOMBREREPORTE = this.reporteSeleccionado.CNFGIMPR_REPORTE;
          NOMBREREPORTE = NOMBREREPORTE.substr(0, NOMBREREPORTE.length - 7);
          strPantallaArchivoRP = NOMBREREPORTE + '_XLS.jasper';
      // }
          this.reporteSer.generarReporte(strPantallaArchivoRP, strConsulta, true, '').subscribe(response => {
            let base64: string = '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';
            base64 = response;
            let byteCharacters = atob(base64);
            let byteArrays = [];
            for (let offset = 0; offset < byteCharacters.length; offset += 512) {
              let slice = byteCharacters.slice(offset, offset + 512);
              let byteNumbers = new Array(slice.length);
              for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
              }
              let bytearray = new Uint8Array(byteNumbers);
              byteArrays.push(bytearray);
            }
            let blob = new Blob(byteArrays, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const fileURL = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.setAttribute('style', 'display: none;');
            a.href = fileURL;
            a.download = strPantallaArchivoRP + '.xlsx';
            a.click();
            window.URL.revokeObjectURL(fileURL);
          }, error => {
            this.messageService.add({
              key: 'cfngimpr',
              severity: 'error',
              summary: 'Error',
              detail: 'Error al generar el reporte. Revise la configuración'
            });
          });
        } else {
          const mediaType = 'application/pdf';
          this.reporteSer.generarReporte(strPantallaArchivoRP, strConsulta, false, '').subscribe(response => {
            const blob = new Blob([response], { type: mediaType });
            const fileURL = URL.createObjectURL(blob);

            window.open(fileURL);
          }, error => {
            this.messageService.add({
              key: 'cfngimpr',
              severity: 'error',
              summary: 'Error',
              detail: 'Error al generar el reporte. Revise la configuración'
            });
          });
        }

        /*console.log(strConsulta);
        document.getElementById('areporte').click();*/

        /*const urlreporte = sessionStorage.getItem('urlreporte');
        const usuarioEsquema = JSON.parse(sessionStorage.getItem('usuarioEsquema'));
        const esquema = usuarioEsquema.esquema;
        let NOMBREREPORTE = strPantallaArchivoRP;
        NOMBREREPORTE = NOMBREREPORTE.substr(0, NOMBREREPORTE.length - 7);
        const src = urlreporte + NOMBREREPORTE + '.pdf?j_username=' + esquema + '&j_password=jasperadmin';
        // src = src + '&j_querryString=' + strConsulta;
        console.log(src);
        // http://localhost:8081/jasperserver/rest_v2/reports/reports/VEN_OP1_NOTAVENTA.pdf?j_username=DEMO&j_password=jasperadmin
        fetch(src).then(res => res.blob()).then(blob => {
          const fileURL = URL.createObjectURL(blob);
          window.open(fileURL);
        });*/
      }, 2000);
      /*
      Map < String, Object > param = new HashMap<String, Object>();
      //System.out.println("Valor de la consulta: "+ strConsulta);
      param.put('querryString', strConsulta);
      param.put('SUBREPORT_DIR', AsistenteReportes.seleccionarInputStreamPantalla(strLocalizacionRP));
      param.put('NOMBRE_REPORTE', strNombreReporte);
      param.put('REPORT_LOCALE', new java.util.Locale('en', 'US'));
      
      try {
        AsistenteReportes.mostrarReportePantalla(strPantallaArchivoRP, param, strLocalizacionRP, '');
      }*/
    }
  }

  imprimir() {

  }

  mandarinforeporte(reporte) {
    if (reporte !== undefined) {
      this.reporteSeleccionado = reporte;
    }
  }

  FunCnfgMtrzRpt(strCampo, strNumDoc) {
    const intNumeroDatos = 2;
    this.ValoresReporte[0] = [];
    this.ValoresReporte[1] = [];
    this.ValoresReporte[0][0] = strCampo;
    //this.ValoresReporte[0][1] = strNumDoc.trim();
    this.ValoresReporte[0][1] = strNumDoc.toString().trim();//CDPJ
    this.ValoresReporte[1][0] = 'COM_CODIGO';
    this.ValoresReporte[1][1] = '01';
    this.intNumFilasVR = intNumeroDatos;
  }

  FunCnfgMtrzRptConcil(strCampo, strNumDoc, strCampo2, strNumDoc2) {
    const intNumeroDatos = 3;
    this.ValoresReporte[0] = [];
    this.ValoresReporte[1] = [];
    this.ValoresReporte[2] = [];
    this.ValoresReporte[0][0] = strCampo;
    this.ValoresReporte[0][1] = strNumDoc.trim();
    this.ValoresReporte[1][0] = strCampo2;
    this.ValoresReporte[1][1] = strNumDoc2.trim();
    this.ValoresReporte[2][0] = 'COM_CODIGO';
    this.ValoresReporte[2][1] = '01';
    this.intNumFilasVR = intNumeroDatos;
  }

  ejecutarReporte() {
    /*this.mensaje = '';
    this.msgs = [];
    console.log(this.reporteSeleccionado);
    if (this.reporteSeleccionado.RL_OBJETO.toString().includes('TMP')) {
      this.reporteSer.eliminarTabla(this.reporteSeleccionado.RL_OBJETO).subscribe(data => {
        this.reporteSer.ejecutarProcedure(this.etiquetas2, this.etiquetas, this.reporteSeleccionado).subscribe(() => {
          this.mensaje = 'Ejecución exitosa';
          this.msgs.push({severity: 'success', summary: '', detail: this.mensaje});
        }, error1 => {
          let mensaje: string;
          mensaje = this.errorService.generarMensajeErrorCompleto(error1.error);
          this.mensaje = 'Error al ejecutar el proceso';
          this.msgs.push({severity: 'error', summary: '', detail: this.mensaje});
        });
      });
    } else {
      this.reporteSer.ejecutarProcedure(this.etiquetas2, this.etiquetas, this.reporteSeleccionado).subscribe(() => {
        this.mensaje = 'Ejecución exitosa';
        this.msgs.push({severity: 'success', summary: '', detail: this.mensaje});
      }, error1 => {
        let mensaje: string;
        mensaje = this.errorService.generarMensajeErrorCompleto(error1.error);
        this.mensaje = 'Error al ejecutar el proceso';
        this.msgs.push({severity: 'error', summary: '', detail: this.mensaje});
      });
    }*/
  }

  FormarConsultaProceso() {
    const fechaSistema = new Date();
    const lngdfechaSistema = fechaSistema.getTime();
    const strParametroIDE = lngdfechaSistema.toString();
    this.ValorParametroIDE = strParametroIDE;

    let strValorParam = '';
    let strCadenaFinal = '';
    for (let i = 0; i < this.intNumfilasVP; i++) {
      if (this.ValoresParamentros[i][0] === 'C') {
        const strValor = this.ValoresParamentros[i][1];
        const strTipoValor = this.ValoresParamentros[i][2];
        for (let j = 0; j < this.intNumFilasVR; j++) {
          if (strValor === this.ValoresReporte[j][0]) {
            strValorParam = this.ValoresReporte[j][1];
            if (strTipoValor === 'S') {
              strValorParam = ',\'' + strValorParam + '\'';
            }
            if (strTipoValor === 'N') {
              strValorParam = ', ' + strValorParam + '';
            }
            strCadenaFinal = strCadenaFinal + '' + strValorParam;
          }
        }
      }
    }
    strCadenaFinal = strCadenaFinal.substring(1);
    this.strObjeto = this.reporteSeleccionado.CNFGIMPR_TABLA;
    //strCadenaFinal = 'BEGIN ' + this.reporteSeleccionado.CNFGIMPR_SP + '(' + strCadenaFinal + ',\'' + strParametroIDE + '\'' + ');END;';
    //CDPJ
    console.log('cadena final', strCadenaFinal);
    console.log('esq', this.cfngimprService.usuarioEsquema.esquema);
    console.log('str', this.strform)
    if (this.cfngimprService.usuarioEsquema.esquema === 'UIO1792788862001' && this.strform === 'Si') {
      strCadenaFinal = 'BEGIN ' + this.reporteSeleccionado.CNFGIMPR_SP + '(' + strCadenaFinal + ',\'' + strParametroIDE + '\'' + ',\'' + this.cfngimprService.usuario.identificacion + '\'' + ');END;';
    } else {
      strCadenaFinal = 'BEGIN ' + this.reporteSeleccionado.CNFGIMPR_SP + '(' + strCadenaFinal + ',\'' + strParametroIDE + '\'' + ');END;';
    }
    console.log('cadena final2', strCadenaFinal);
    //CDPJ
    return strCadenaFinal;
  }
}
